import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestDMPost } from 'modules/fetch/api';

const SEND_COMPLAINT = 'sendComplaint/SEND_COMPLAINT';
const COMPLAINT_RESULT = 'sendComplaint/COMPLAINT_RESULT';

export const sendComplaint = createAction(SEND_COMPLAINT);

export function* sendComplaintaction(action) {
  try {
    if (action.payload.status !== 'stop') {
      const instr = `민원 접수 입력 → 
      ${action.payload.call ? `연락처 : ${action.payload.call}, ` : ''}
      ${action.payload.addr ? `주소 : ${action.payload.addr}, ` : ''}
      ${action.payload.region ? `지역 : ${action.payload.region}, ` : ''}
      ${action.payload.type_code ? `유형코드 : ${action.payload.type_code}, ` : ''}
      ${action.payload.main_type ? `상위유형(대분류) : ${action.payload.main_type}, ` : ''}
      ${action.payload.sub_type ? `하위유형(소분류) : ${action.payload.sub_type}, ` : ''}
      ${action.payload.content ? `내용 : ${action.payload.content}, ` : ''}`;

      const paramSet = {
        user_id: sessionStorage.getItem('user_id'),
        in_type: 'query',
        in_str: instr,
        session_id: sessionStorage.getItem('session_id'),
        channel_id: sessionStorage.getItem('device'),
        parameters: { complaint: JSON.stringify(action.payload) },
      };

      const response = yield call(requestDMPost, paramSet);
      const getComplaint = response.data.data?.result?.fulfillment?.messages || [];

      let result = [];
      let resultData = [];
      if (getComplaint.length > 0) {
        result = getComplaint[0].items[0].value.value || '300';

        if (result === '200') {
          resultData = getComplaint[0].items[0].result_data.value;
        } else {
          resultData = '';
        }
      }

      yield put({
        type: COMPLAINT_RESULT,
        payload: {
          result: result || [],
          result_data: resultData || [],
          msg: response.data.data.result.fulfillment.speech || '접수번호 및 연락처를 다시 확인해 주세요',
        },
      });
    } else {
      yield put({
        type: COMPLAINT_RESULT,
        payload: {
          result: 0,
        },
      });
    }
  } catch (error) {
    yield put({
      type: COMPLAINT_RESULT,
      payload: {
        result: 100,
      },
    });
  }
}

export function* sendComplaintSaga() {
  yield takeLatest(SEND_COMPLAINT, sendComplaintaction);
}

const initialState = {
  result: [],
  result_data: [],
  msg: '',
};

export default handleActions(
  {
    [COMPLAINT_RESULT]: (state, action) => ({
      ...state,
      result: action.payload.result,
      result_data: action.payload.resultData,
      msg: action.payload.msg,
    }),
  },
  initialState
);
